<template>

  <div class="home mr-4">

    <v-flex xs12 sm6 md4 lg4 offset-lg0 xl3 offset-xl0 offset-sm0 class="my-4">

      <v-card>
        <v-card-media
        v-bind:src="require('@/assets/profile-pic.png')"
        >
        </v-card-media>

        <v-card-title primary-title>
          <div >
            <h3 class="headline mb-0">Rohan Ghuge</h3>
            <p style = "font-family:georgia,garamond,serif;font-size:16px;font-style:italic;"> Assistant Professor<br>
             IROM, McCombs School of Business<br>
            The University of Texas at Austin</p>
          </div>
        </v-card-title>

        <v-card-actions>
          <v-btn href="https://drive.google.com/file/d/1F2Dr3EgVlt7qJO4OJV1N2gVyB9PE13Wz/view?usp=sharing" flat color="indigo darken-1">
            <v-icon left> description </v-icon>
            CV
          </v-btn>
          <v-btn flat color="indigo darken-1" @click.stop="dialog = true">
            <v-icon left> email </v-icon>
            Email
          </v-btn>

          <v-dialog
          v-model="dialog"
          max-width="290"
          >
          <v-card>
            <v-card-text>rohan.ghuge@mccombs.utexas.edu</v-card-text>
          </v-card>
        </v-dialog>


        </v-card-actions>
      </v-card>
      </v-flex>

      <!--
    <div class="my-4" id="about" >
    <h1 class="headline indigo--text text-darken-1 font-weight-bold" >About Me</h1>

    <p class="mt-2 subheading">
      I am an Assistant Professor of Decision Science in the <a href="https://www.mccombs.utexas.edu/faculty-research/departments/irom/">Department of Information, Risk, and Operations Management</a> (IROM) at the McCombs School of Business at the University of Texas at Austin.
      Prior to joining the IROM department, I was a Ronald J. and Carol T. Beerman / ARC Postdoctoral Fellow at the Georgia Institute of Technology, working with
       <a href="https://vmuthukumar.ece.gatech.edu/">Vidya Muthukumar</a>, <a href="https://www2.isye.gatech.edu/~msingh94/">Mohit Singh</a> and <a href="https://faculty.cc.gatech.edu/~ssingla7/">Sahil Singla</a>.
      And before that, I completed my Ph.D. in Industrial and Operations Engineering at the University of Michigan
      where I was advised by <a href="https://viswa.engin.umich.edu/">Viswanath Nagarajan</a>.
    </p>

    </div>
  -->

    <div class="my-4" id="about" >
    <h1 class="headline indigo--text text-darken-1 font-weight-bold" >New Website</h1>

    <p class="mt-2 subheading">
      My website has moved <a href="https://rohanghuge.com">here</a>.
    </p>

    </div>

<!--
      <div id="research" class="my-4">
        <h1 class="headline indigo--text text-darken-1 font-weight-bold">Research Interests</h1>

        <p class="mt-2 subheading">
          My research focuses on designing <b> data-driven algorithms</b> for problems involving <b>uncertainty</b>.
          In particular, I employ data-driven methods and machine learning techniques in <b>stochastic optimization</b>,
          where the input is unknown but the distribution over input instances is known.
          My work centers on three primary themes:
          <ul>
            <br>
          <li> exploring the <b>power of adaptivity</b>—the ability of an algorithm to adjust its decisions
            based on newly acquired feedback, particularly focusing on how limited rounds of feedback
            can still yield near-optimal solutions; </li>
            <br>
          <li> developing robust algorithms for <b>online decision-making</b>,
            which involves making irrevocable choices without foresight,
            with an emphasis on ensuring reliable performance under noisy or uncertain data; and </li>
            <br>
          <li> tackling the dual challenge of <b>learning problem parameters</b> while simultaneously optimizing decisions,
            with a particular focus on analyzing the convergence rate of such algorithms to optimal solutions.</li>
        </ul>
        <br>
        These considerations are critical in applications like healthcare diagnostics, preference elicitation on online platforms,
        ad placement in response to search queries, and web search ranking.
        Through this work, I aim to advance both the practical and theoretical understanding of
        integrating machine learning techniques into decision-making under uncertainty.
         </p>
       </div>
-->


       <!--<div id="research" class="my-4">
         <h1 class="headline indigo--text text-darken-1 font-weight-bold">I am on the 2024-25 academic job market!</h1>


         <p class="mt-2 subheading">
         Some of my ongoing work will be featured at the 2024 INFORMS Annual Meeting in Seattle.<br><br>

         <b> I will be presenting ‘Exponential Pricing for Online Resource Allocation’ in Session TC29 - Sequential Decision Making - on Tuesday (October 22) at 12:45pm. </b><br><br>

         Other presentations include:
         <ul>
           <br>
         <li> Yihua Xu will present <b>Stochastic Scheduling with Abandonments via Greedy Strategies</b> in
Session TC29 - Sequential Decision Making. </li>
           <br>
         <li> Dr. Viswanath Nagarajan will present <b>Semi-bandit Learning for Monotone Stochastic Optimization</b> in Session WB76 - Online and Adaptive Optimization. </li>
           <br>
         <li> Rayen Tan will present <b>Informative Path Planning with Limited Adaptivity</b> in Session
TC33 - Stochastic Programming with Endogenous Uncertainty. </li>
       </ul>
     </p>
       </div>-->


<!--
       <h1 class="headline indigo--text text-darken-1 font-weight-bold">Submitted Papers</h1>
         <ul>

           <li>
             <div class="mt-4 subheading">
               <p ><b>Stochastic Scheduling with Abandonments via Greedy Strategies.</b><br>
                 Yihua Xu, Rohan Ghuge and Sebastian Perez-Salazar.
               </p>
             </div>
           </li>



         </ul>-->

<!--
      <div id="publications" class="my-4">


        <h1 class="headline indigo--text text-darken-1 font-weight-bold">Journal Publications</h1>


          <ul>

            <li>
              <div class="mt-4 subheading">
                <p ><b>Sequential Selection with Expirations.</b><br>
                  Yihua Xu, Rohan Ghuge and Sebastian Perez-Salazar.<br>
                  Submitted.<br>
                </p>
              </div>
            </li>

            <li>
              <div class="mt-4 subheading">
                <p ><b>Semi-Bandit Learning for Monotone Stochastic Optimization.</b><br>
                  Rohan Ghuge, Zhengjia Zhuo, Arpit Agarwal and Viswanath Nagarajan.
                  <a href="https://arxiv.org/pdf/2312.15427.pdf">[PDF]</a><br>
                  Submitted.<br>
                   <small>Full version of FOCS 2024 paper.</small>
                </p>

              </div>
            </li>

            <li>
              <div class="mt-4 subheading">
                <p ><b>Informative Path Planning with Limited Adaptivity.</b><br>
                  Rayen Tan, Rohan Ghuge and Viswanath Nagarajan.
                  <a href="https://arxiv.org/pdf/2311.12698.pdf">[PDF]</a><br>
                  INFORMS Journal of Computing (Minor Revision).<br>
                   <small>Full version of AISTATS 2024 paper.</small>
                </p>

              </div>
            </li>

            <li>
              <div class="mt-4 subheading">
                <p ><b>Non-Adaptive Stochastic Score Classification annd Explainable Halfspace Evaluation</b><br>
                  Rohan Ghuge, Anupam Gupta and Viswanath Nagarajan.
                  <a href="https://arxiv.org/pdf/2111.05687.pdf">[PDF]</a><br>
                  Operations Research, 73(4), 2204-2222, 2025. <a href="https://pubsonline.informs.org/doi/10.1287/opre.2023.0431">[DOI]</a><br>
                  <small>Full version of IPCO 2022 paper.</small>
                </p>
              </div>
            </li>

            <li>
              <div class="mt-4 subheading">
                <p ><b>The Power of Adaptivity for Stochastic Submodular Cover.</b><br>
                  Rohan Ghuge, Anupam Gupta and Viswanath Nagarajan.
                  <a href="https://arxiv.org/pdf/2106.16115.pdf">[PDF]</a><br>
                  Operations Research, 72(3): 1156-1176, 2024. <a href="https://pubsonline.informs.org/doi/full/10.1287/opre.2022.2388">[DOI]</a><br>
                  <small>Full version of ICML 2021 paper.</small>
                </p>
              </div>
            </li>


            <li>
              <div class="mt-4 subheading">
                <p ><b>Constrained Assortment Optimization under the Paired Combinatorial Logit Model.</b><br>
                  Rohan Ghuge, Joseph Kwon, Viswanath Nagarajan and Adetee Sharma.
                  <a href="http://www.optimization-online.org/DB_FILE/2019/01/7017.pdf">[PDF]</a><br>
                  Operations Research, 70(2): 786-804, 2022. <a href="https://pubsonline.informs.org/doi/abs/10.1287/opre.2021.2188">[DOI]</a><br>
                </p>
              </div>
            </li>

            <li>
              <div class="mt-4 subheading">
                <p ><b>Quasi-Polynomial Algorithms for Submodular Tree Orienteering and Other Directed Network Design Problems.</b><br>
                  Rohan Ghuge and Viswanath Nagarajan.
                  <a href="https://arxiv.org/pdf/1812.01768.pdf">[PDF]</a><br>
                  Mathematics of Operations Research, 47(2):1612-1630, 2022. <a href="https://doi.org/10.1287/moor.2021.1181">[DOI]</a><br>
                  <small>Full version of SODA 2020 paper.</small>
                </p>
              </div>
            </li>
          </ul>

          <br>

          <h1 class="headline indigo--text text-darken-1 font-weight-bold">Conference Publications</h1>

          <ul>

            <li>
              <div class="mt-4 subheading">
                <p ><b>Improved and Oracle-Efficient Online <span v-katex="' l_1 '"></span>-Multicalibration.</b><br>
                  Rohan Ghuge, Vidya Muthukumar, and Sahil Singla.
                  <a href="https://arxiv.org/pdf/2505.17365.pdf">[PDF]</a><br>
                  International Conference on Machine Learning (ICML 2025). <a href = "https://proceedings.mlr.press/v267/ghuge25a.html">[DOI]</a>.
                </p>
              </div>
            </li>

            <li>
              <div class="mt-4 subheading">
                <p ><b>Single-Sample and Robust Online Resource Allocation.</b><br>
                  Rohan Ghuge, Sahil Singla and Yifan Wang.
                  <a href="https://arxiv.org/pdf/2505.02963.pdf">[PDF]</a><br>
                  Symposium on Theory of Computing (STOC 2025). <a href = "https://dl.acm.org/doi/10.1145/3717823.3718246">[DOI]</a>.
                </p>
              </div>
            </li>

            <li>
              <div class="mt-4 subheading">
                <p ><b>Semi-Bandit Learning for Monotone Stochastic Optimization.</b><br>
                  Arpit Agarwal, Rohan Ghuge and Viswanath Nagarajan.
                  <a href="https://arxiv.org/pdf/2312.15427.pdf">[PDF]</a><br>
                  Symposium on Foundations of Computer Science (FOCS 2024). <a href = "https://ieeexplore.ieee.org/abstract/document/10756016">[DOI]</a>.
                </p>
              </div>
            </li>

            <li>
              <div class="mt-4 subheading">
                <p ><b>Informative Path Planning with Limited Adaptivity.</b><br>
                  Rayen Tan, Rohan Ghuge, and Viswanath Nagarajan.
                  <a href="https://arxiv.org/pdf/2311.12698.pdf">[PDF]</a><br>
                  International Conference on Artificial Intelligence and Statistics (AISTATS 2024). <a href="https://proceedings.mlr.press/v238/tan24a.html">[DOI]</a>.
                </p>
              </div>
            </li>

            <li>
              <div class="mt-4 subheading">
                <p ><b>An Asymptotically Optimal Batched Algorithm for the Dueling Bandit Problem.</b><br>
                  Arpit Agarwal, Rohan Ghuge, and Viswanath Nagarajan.
                  <a href="https://arxiv.org/pdf/2209.12108.pdf">[PDF]</a><br>
                  Neural Information Processing Systems (NeurIPs 2022). <a href="https://proceedings.neurips.cc/paper_files/paper/2022/hash/b9e472cd579c83e2f6aa3459f46aac28-Abstract-Conference.html">[DOI]</a>.
                </p>
              </div>
            </li>

            <li>
              <div class="mt-4 subheading">
                <p ><b>Batched Dueling Bandits.</b><br>
                  Arpit Agarwal, Rohan Ghuge, and Viswanath Nagarajan.
                  <a href="https://arxiv.org/pdf/2202.10660.pdf">[PDF]</a><br>
                  International Conference on Machine Learning (ICML 2022). Long talk (top 2% of submissions). <a href = "https://proceedings.mlr.press/v162/agarwal22a.html">[DOI]</a>.
                </p>
              </div>
            </li>

            <li>
              <div class="mt-4 subheading">
                <p ><b>Non-Adaptive Stochastic Score Classification and Explainable Halfspace Evaluation.</b><br>
                  Rohan Ghuge, Anupam Gupta and Viswanath Nagarajan.
                  <a href="https://arxiv.org/pdf/2111.05687.pdf">[PDF]</a><br>
                  International Conference on Integer Programming and Combinatorial Optimization (IPCO 2022). <a href = "https://link.springer.com/chapter/10.1007/978-3-031-06901-7_21">[DOI]</a>.
                </p>
              </div>
            </li>

            <li>
              <div class="mt-4 subheading">
                <p ><b>The Power of Adaptivity for Stochastic Submodular Cover.</b><br>
                  Rohan Ghuge, Anupam Gupta and Viswanath Nagarajan.
                  <a href="https://arxiv.org/pdf/2106.16115.pdf">[PDF]</a><br>
                  International Conference on Machine Learning (ICML 2021). Long talk (top 3% of submissions). <a href = "https://proceedings.mlr.press/v139/ghuge21a.html">[DOI]</a>.
                </p>
              </div>
            </li>

            <li>
              <div class="mt-4 subheading">
                <p ><b>Quasi-Polynomial Algorithms for Submodular Tree Orienteering and Other Directed Network Design Problems.</b><br>
                  Rohan Ghuge and Viswanath Nagarajan.
                  <a href="https://arxiv.org/pdf/1812.01768.pdf">[PDF]</a><br>
                  Symposium on Discrete Algorithms (SODA 2020). <a href="https://dl.acm.org/doi/10.5555/3381089.3381152">[DOI]</a><br>
                </p>
              </div>
            </li>

          </ul>




      </div>

      <div id="teaching" class="mt-4">
        <h1 class="headline indigo--text text-darken-1 font-weight-bold">Teaching Experience</h1>

        <ul>

          <li>
            <div class="mt-2 subheading">
            <p ><b>At Georgia Institute of Technology, as an Instructor.</b></p>
          </div>
          <div class=" body-2">
            <ul>
               <li>Summer 2024, Online Learning and Decision-Making (ISyE 4601)</li>
           </ul>

           </div>
          </li>

         <li>
           <div class="mt-2 subheading">
           <p ><b>At the University of Michigan, as a Graduate Student Instructor.</b></p>
         </div>
         <div class=" body-2">
           <ul>
              <li>Fall 2019, Stochastic Processes I (IOE 515)</li>
              <li>Winter 2020, Advanced Optimization Methods (IOE 410)</li>
          </ul>

          </div>
         </li>

         <br>

         <li>
           <div class="mt-2 subheading">
           <p ><b>At the University of Pennsylvania, as a Teaching Assistant.</b></p>
         </div>
         <div class=" body-2">
           <ul>
              <li>Spring 2017, Introduction to Algorithms (CIS 320)</li>
              <li>Summer 2017, Analysis of Algorithms (CIS 502)</li>
              <li>Fall 2017, Machine Learning (CIS 520)</li>
              <li>Spring 2018, Introduction to Algorithms (CIS 320)</li>
              <li>Spring 2018, Introduction to Probability (ESE 301)</li>

          </ul>

          </div>
         </li>

       </ul>


      </div>
      -->

      <div class="hidden-md-and-up">
        <p class="mt-2 subheading">Visit my blog <a href="https://rghuge-94.firebaseapp.com/blog">here</a>.</p>
      </div>

  </div>






</template>

<script>

  export default {

    data () {
      return {
        dialog: false
      }
    }

  }
</script>
